import { render, staticRenderFns } from "./SparkrunRecipes.vue?vue&type=template&id=5418765a"
import script from "./SparkrunRecipes.vue?vue&type=script&lang=ts"
export * from "./SparkrunRecipes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports